import React, {FC} from 'react';
import {NavLink} from 'react-router-dom';
import {ReactSVG} from 'react-svg';

import {logo2} from 'assets';
import {MenuItem} from 'types';

import './style.scss';

type PropsTypes = {
	navItems: MenuItem[];
	isOpenMenu: boolean;
	menuHandler: (boolean) => void;
};

const Menu: FC<PropsTypes> = ({navItems, isOpenMenu, menuHandler}) => {
	const navButtons = navItems.map(item => {
		return (
			<a href={`#t${item.type}`} key={item.label} onClick={() => menuHandler(false)}>
				<li className={`nav-item t${item.type} icon`} id={`nav-item${item.type}`}>
					<ReactSVG src={item.icon} className="nav-item__icon" alt="nav-icon" />
					<span className="nav-item__text">{item.label}</span>
				</li>
			</a>
		);
	});

	return (
		<ul id="menu" className={`${isOpenMenu ? 'open' : ''}`}>
			<NavLink className="logo" to="/home">
				<ReactSVG src={logo2} alt="Logo" />
			</NavLink>
			{navButtons}
		</ul>
	);
};

export default Menu;
